import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getDataBoundarySlice = createSlice({
  name: "getDataBoundary",
  initialState,
  reducers: {
    getDataBoundaryStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getDataBoundarySuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDataBoundaryFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getDataBoundaryStart,
  getDataBoundarySuccess,
  getDataBoundaryFailed,
} = getDataBoundarySlice.actions;

export default getDataBoundarySlice.reducer;
